import '@wordpress/notices';
export default ( {account, applying, setApplying} ) => {

	const NOTICE_ID = 'zap-cashier-checkout-notice';

	const SendApplyAccount = ( account_type ) => {

		setApplying(true);

		fetch(ZapCashierCheckout.ajax, {
			method: 'POST',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				'Accept': 'application/json, text/plain, */*',
			},
			body: new URLSearchParams({
				action: ZapCashierCheckout.action,
				account: account_type,
				nonce: ZapCashierCheckout.apply_discount_nonce,
			}),
        }).then( async ( response ) => {

            const text = await response.text();

            let result = null;

            try {
                result = JSON.parse( text );
            } catch ( error ) {
                throw new Error(
                    'Unexpected checkout response. Please refresh and try again.'
                );
            }

            if ( ! response.ok ) {
                throw new Error(
                    result.data || `HTTP error ${response.status}`
                );
            }

            return result;

        }).then( ( result ) => {

            if ( ! result.success ) {
                throw new Error( result.data || 'Unknown error applying account.' );
            }
            wp.data.dispatch( 'core/notices' ).removeNotice( NOTICE_ID );

            // Refresh cart/checkout to show coupon has been applied.
            wp.data.dispatch( 'wc/store/cart' ).invalidateResolutionForStore();

        }).catch(( error ) => {

            // Clear notices
            wp.data.dispatch( 'core/notices' ).removeNotice( NOTICE_ID );

            // Display the new error
            wp.data.dispatch( 'core/notices' ).createWarningNotice(
                error.message || 'Unable to apply account balance.', {
                    id: NOTICE_ID,
                    context: 'wc/checkout',
                }

            );
        }).finally( () => {

            // Always reset state.
            setApplying( false );
        });
	}

	return (

		<div className="zap-cashier-checkout-account">
			<p className="zap-cashier-checkout-account-label"><strong>Pay using your {account.account_label}</strong> ({account.account_balance_formatted})</p>
			<button disabled={ applying } type="button" onClick={(event) => { event.preventDefault(); SendApplyAccount(account.account_type) }} className="zapc-checkout-button small">
				Apply { ! applying && (<i className="fa fa-caret-right"></i>)  }

				{ applying && ( <i className="fa fa-spinner fa-spin"></i> ) }

			</button>
		</div>
	);
}